import React, { useEffect, useRef } from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import { ModalUi } from "../../../../ui/ModalUi";
import { ButtonUi } from "../../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../../types/typesConstants";
import { FormUi } from "../../../../ui/FormUi";
import { SearchFormProgramacionTintoreriaForm } from "./SearchFormProgramacionTejidoForm";
const initialValues = (data = {}) => ({
  detalleprogramaciontintoreria: null,
});
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;
  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
  }, [form, prevOpen, open]);
};
export const SearchFormProgramacionTintoreriaModal = ({
  programaciontintoreria,
  open,
  onCancel,
}) => {
  const [form] = Form.useForm();
  useResetFormOnCloseModal({ form, open });

  const handleSave = (values) => {
    onCancel();
  };
  return (
    <ModalUi
      title="Programaciones tintoreria"
      centered
      maskClosable={false}
      destroyOnHidden
      open={open}
      onCancel={onCancel}
      width="60%"
      footer={[
        <ButtonUi
          key="back"
          typeUi={TipoButtonConstants.Cancelar}
          onClick={onCancel}
        />,
        <ButtonUi
          key="submit"
          typeUi={TipoButtonConstants.Guardar}
          htmlType="submit"
          form="FormDetalleProgramacionTintoreria"
        />,
      ]}
    >
      <FormUi
        name="FormDetalleProgramacionTintoreria"
        form={form}
        autoComplete="off"
        initialValues={initialValues}
        handleSubmit={handleSave}
      >
        <SearchFormProgramacionTintoreriaForm
          open={open}
          programaciontintoreria={programaciontintoreria}
        />
      </FormUi>
    </ModalUi>
  );
};
